import { onMounted, nextTick } from "vue";
import { WOW } from "wowjs";
export default (): void => {
  onMounted(() => {
    nextTick(() => {
      new WOW().init();
    });
  });
};
